module.exports = "<div class=\"header-secondary\">\n  <logo region=\"vm.region\"></logo>\n  <div class=\"header-secondary-title\">\n    <h1>{{vm.pageTitle}}</h1>\n  </div>\n  <div class=\"weather-icons-container\">\n    <weather-icons region=\"vm.region\"></weather-icons>\n  </div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/common/headerSecondary/headerSecondary.html
 ** module id = 135
 ** module chunks = 0
 **/